import React, { useEffect } from 'react';
import { useAds } from 'hooks/use-ads';
import { AdSlotMarker, AdSlotMarkerProps } from '../ad-slot-marker/ad-slot-marker';
import './ad-slot.scss';

const AdSlot: React.FC<AdSlotMarkerProps> = ({ id, name, lazy, resizable, className = '' }) => {
    const ads = useAds();
    const disabledSlots = ads?.disabledSlots ?? [];
    const disabled = !ads || !ads.enabled || disabledSlots.includes(name);

    useEffect((): void => {
        if (disabled === false) {
            window?.onetAds?.cmd.push((dlApi): void => dlApi.defineSlot(name, id || `ad-${name}`, {}).setCollapseEmpty(true));
        }
    }, []);

    if (disabled) {
        return null;
    }

    return <AdSlotMarker id={id || `ad-${name}`} name={name} auto={false}
        lazy={lazy} resizable={resizable} className={className}
    />;
};

export default AdSlot;
